import { createSvgIcon } from '@mui/material';
import React from 'react';
export const DirectorChairIcon = createSvgIcon(
    <svg height="24px" width="24px" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
            d="M28.2,11c0.4-0.1,0.8-0.5,0.8-1V1c0-0.3-0.1-0.6-0.4-0.8S28.1,0,27.8,0C20.1,2,11.9,2,4.2,0C3.9,0,3.6,0,3.4,0.2
   C3.1,0.4,3,0.7,3,1v9c0,0.5,0.3,0.9,0.8,1c0.4,0.1,0.8,0.2,1.2,0.3v4c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.6,0-0.9,0.2
   C3.1,15.4,3,15.7,3,16v3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2
   c0,0,0,0,0,0l10.3,5.4l-9.3,4.9C4,30.4,3.9,31,4.1,31.5C4.3,31.8,4.6,32,5,32c0.2,0,0.3,0,0.5-0.1L16,26.4l10.5,5.5
   C26.7,32,26.8,32,27,32c0.4,0,0.7-0.2,0.9-0.5c0.3-0.5,0.1-1.1-0.4-1.3l-9.3-4.9l10.3-5.4c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.2
   c0,0,0,0,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2v-3c0-0.3-0.1-0.6-0.4-0.8C28.4,15,28.1,15,27.8,15
   c-0.3,0.1-0.5,0.1-0.8,0.2v-4C27.4,11.1,27.8,11.1,28.2,11z M10.3,21.1c1.9,0.2,3.8,0.3,5.7,0.3s3.8-0.1,5.7-0.3l-5.7,3L10.3,21.1z
    M25,15.6c-5.9,1.1-12.1,1.1-18,0v-4c3,0.5,6,0.8,9,0.8s6-0.3,9-0.8V15.6z"
        />
    </svg>,
    'DirectorChairIcon',
);
